import * as yup from 'yup'
import plate from './plate'
import rntrc from './rntrc'
import capacity from './capacity'

yup.addMethod(yup.string, 'plate', plate)
yup.addMethod(yup.string, 'rntrc', rntrc)
yup.addMethod(yup.string, 'capacity', capacity)

yup.setLocale({
  mixed: {
    required: 'Campo obrigatório.',
  },
})

export * from 'yup'
